"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOAuthV2LogoutUrl = exports.getOAuthV2TokenUrl = exports.getOAuthV2AuthorizeUrl = exports.OAUTH_CHANGE_PASSWORD_URL = exports.OAUTH_RESET_PASSWORD_CONFIRM_URL = exports.OAUTH_RESET_PASSWORD_URL = exports.OAUTH_FORGOT_PASSWORD_URL = exports.OAUTH_V1_TOKEN_URL = exports.JWKS_URL = void 0;
const config_1 = __importDefault(require("next/config"));
const { serverRuntimeConfig = {} } = (0, config_1.default)();
const { authServerUrl, myAccountUri = {} } = serverRuntimeConfig;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let createUrl = (path, base) => path;
if (!process.browser) {
    createUrl = (path, base) => new URL(path, base);
}
exports.JWKS_URL = createUrl(`/.well-known/jwks.json`, authServerUrl);
/** @deprecated */
exports.OAUTH_V1_TOKEN_URL = createUrl(`/token`, authServerUrl);
exports.OAUTH_FORGOT_PASSWORD_URL = createUrl(`/forgot-password`, authServerUrl);
exports.OAUTH_RESET_PASSWORD_URL = createUrl(`/reset-password/email`, authServerUrl);
exports.OAUTH_RESET_PASSWORD_CONFIRM_URL = createUrl(`/reset-password`, authServerUrl);
exports.OAUTH_CHANGE_PASSWORD_URL = createUrl(`/change-password`, authServerUrl);
const getOAuthV2AuthorizeUrl = (language) => language in myAccountUri
    ? createUrl(`/v2/authorize`, myAccountUri[language])
    : null;
exports.getOAuthV2AuthorizeUrl = getOAuthV2AuthorizeUrl;
const getOAuthV2TokenUrl = (language) => language in myAccountUri
    ? createUrl(`/v2/token`, myAccountUri[language])
    : createUrl(`/v2/token`, authServerUrl);
exports.getOAuthV2TokenUrl = getOAuthV2TokenUrl;
const getOAuthV2LogoutUrl = (language) => language in myAccountUri
    ? createUrl(`/v2/logout`, myAccountUri[language])
    : null;
exports.getOAuthV2LogoutUrl = getOAuthV2LogoutUrl;
//# sourceMappingURL=auth.endpoints.js.map